import { GREY_S, GREY_U } from 'app/constants/Colors';
import { BORDER_RADIUS_B,
  SEARCH_INPUT_BOX_SHADOW,
  SEARCH_INPUT_FOCUS_BOX_SHADOW,
  TRANSITION_DURATION_A } from 'app/constants/Styles';

export const inputBaseStyles = {
  color: GREY_S,
  fontSize: '14px',
  border: `1px solid ${GREY_U}`,
  borderRadius: BORDER_RADIUS_B,
  ':focus': {
    outline: 'none',
    border: `1px solid ${GREY_S}`,
  },
  background: 'white',
};

export const inputBoxshadowStyles = (hasFocus: boolean) => ({
  boxShadow: hasFocus ? SEARCH_INPUT_FOCUS_BOX_SHADOW : SEARCH_INPUT_BOX_SHADOW,
  transition: `box-shadow ${TRANSITION_DURATION_A} ease-out`,
});

export const inputHeightPx = 30;
export const inputHeight = `${inputHeightPx}px`;
